import legal from "@/data/legalDocuments.json";

interface MarketingConsentProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  checkboxClassName?: string;
  labelClassName?: string;
}

export default function MarketingConsent({ id, checked, onChange, className = "mt-3 flex items-start gap-2", checkboxClassName = "mt-0.5 h-3.5 w-3.5 shrink-0 rounded border-border accent-accent", labelClassName = "text-left text-sm leading-relaxed text-muted-foreground/70" }: MarketingConsentProps) {
  const document = legal.documents.find((item) => item.id === "marketing");
  return <div className={className}>
    <input id={id} type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} className={checkboxClassName} />
    <label htmlFor={id} className={labelClassName}>
      Хочу получать новости, анонсы мероприятий и материалы WMT AI. {document && <a href={`/legal/${document.slug}.html`} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-foreground">Условия и отзыв</a>}
    </label>
  </div>;
}
